package com.nonopn.skydome.common.app.pages.consultation

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.consultation_expired
import com.nonopn.skywatcher.common.app.res.consultation_loading
import com.nonopn.skywatcher.common.app.res.consultation_provided_by
import com.nonopn.skywatcher.common.app.res.consultation_shared_info
import com.nonopn.skywatcher.common.app.res.consultation_title
import org.jetbrains.compose.resources.stringResource

/**
 * Clean third-party consultation view — Strike Radar Phase 3 (placeholder).
 *
 * Displayed when a third party opens a sharing link.
 * Will be activated once Kevin's backend is ready.
 *
 * Route: /share/{token}
 */
@Suppress("LongMethod", "MagicNumber")
@Composable
fun ConsultationScreen(
    shareToken: String?,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(Color(0xFFF5F7FA))
            .padding(24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        // Strike Radar logo
        Text(
            text = "⚡",
            fontSize = 48.sp
        )
        Spacer(Modifier.height(16.dp))
        Text(
            text = "Strike Radar",
            fontSize = 22.sp,
            fontWeight = FontWeight.Bold,
            color = Color(0xFF1A2B4A)
        )
        Spacer(Modifier.height(8.dp))
        Text(
            text = stringResource(Res.string.consultation_title),
            fontSize = 15.sp,
            color = Color(0xFF6B7A99)
        )
        Spacer(Modifier.height(32.dp))

        Card(
            modifier = Modifier.fillMaxWidth(),
            colors = CardDefaults.cardColors(containerColor = Color.White),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.cardElevation(2.dp)
        ) {
            Column(Modifier.padding(20.dp)) {
                if (shareToken != null) {
                    Text(
                        text = "🔗 " + stringResource(Res.string.consultation_loading),
                        fontSize = 15.sp,
                        color = Color(0xFF2B7FE0),
                        fontWeight = FontWeight.SemiBold
                    )
                    Spacer(Modifier.height(8.dp))
                    Text(
                        text = stringResource(Res.string.consultation_shared_info),
                        fontSize = 13.sp,
                        color = Color(0xFF6B7A99)
                    )
                } else {
                    Text(
                        text = stringResource(Res.string.consultation_expired),
                        fontSize = 15.sp,
                        color = Color(0xFFE63B2E),
                        fontWeight = FontWeight.SemiBold
                    )
                }
            }
        }

        Spacer(Modifier.height(24.dp))

        Text(
            text = stringResource(Res.string.consultation_provided_by),
            fontSize = 11.sp,
            color = Color(0xFF9BA3B2),
            textAlign = TextAlign.Center
        )
    }
}
